import React from 'react';
import Grid from '@material-ui/core/Grid';
import Chat from './Chat'
import ConversationLists from './ConversationLists'
import Profile from './Profiles'
import { sendMessageFirebase } from '../../store/Store'
import avatar from '../../store/assets/davatar.png'
import adbs from 'ad-bs-converter';
import { db } from '../../firebase'


const FIREBASE_REF_PROFILE = db.ref('Users');
const FIREBASE_REF_MESSAGES = db.ref('Messages');

const styles = {
    Paper: {
        height: '95%',
        borderRight: '1px solid #B5B6B5',
        borderLeft: '1px solid #B5B6B5',
        backgroundColor: '#EFF2EF',
      },
}

class Dashboard extends React.Component {
    constructor(props){
        super(props)
        this.setActiveId = this.setActiveId.bind(this)
        this.updateProfile = this.updateProfile.bind(this)
        this.pullConversation = this.pullConversation.bind(this)
        this.state = {
            activeId: '',
            userProfile: {},
            allUserMessages: [],
            allUserDetails: []
        }
    }

    componentDidMount() {
        FIREBASE_REF_PROFILE.once('value').then(snapshot => {
            var rawUsers = snapshot.val()
            var userKeys = Object.keys(rawUsers)
            var userList = userKeys.map(key => {
                return {
                    id: key,
                    avatar: rawUsers[key].avatar ? rawUsers[key].avatar : avatar,
                    name: rawUsers[key].name
                }
            })
            this.setState({allUserDetails: userList})
        })
    }

    sendMessage = (message) => {
        const {adminUid, adminName} = this.props
        sendMessageFirebase(message, this.state.activeId, adminUid, adminName)
        var selectedUser = this.filterUserById(this.state.activeId)[0]
        this.setState(prevState => {
            allUserMessages: prevState.allUserMessages.push({
                message: message,
                avatar: avatar,
                username: selectedUser.name,
                createdAt: this.dateFormatter(Date.now()),
                is_admin: true
            })
        })
    }

    setActiveId(id) {
        this.setState({activeId: id})
    }

    updateProfile(id) {
        FIREBASE_REF_PROFILE.child(id).once('value').then(snapshot => {
            var profile = snapshot.val()
            const { birthDate } = profile
            if(birthDate) {
                var temp = birthDate.split('/')
                var nepaliDate = this.getNepaliDate(temp[2]+'/'+temp[1]+'/'+temp[0])
            }
            profile.nepaliDate = nepaliDate
            this.setState({userProfile: profile})
        })
    }

    dateFormatter(epoch) {
        var d = new Date(epoch)
        var date = d.getDate() 
        + ' ' + d.toLocaleDateString('en-us', {month: 'short'})
        + ', ' + d.getFullYear()
        var time = ('0' + d.getHours()).slice(-2) + ':' + ('0' + d.getMinutes()).slice(-2)
        return {date, time}
    }

    getNepaliDate(adDate) {
        //   { year: '२०४७',
        //      month: '४',
        //      day: '२६',
        //      strMonth: 'श्रावण',
        //      strShortMonth: 'श्रा',
        //      dayOfWeek: '५',
        //      strDayOfWeek: 'शुक्रवार',
        //      strShortDayOfWeek: 'शुक्र',
        //      strMinDayOfWeek: 'शु',
        //      totalDaysInMonth: '३२' }
        var pp = adDate.split('/')
        return adbs.ad2bs(pp[0]+'/'+pp[1]+'/'+pp[2]).ne
    }

    pullConversation(id) {
        FIREBASE_REF_MESSAGES.child(id).once('value', snapshot => {
            var allMessages = snapshot.val()
            var msgKeys = Object.keys(allMessages)
            var selectedUser = this.filterUserById(id)[0]
        
            var msgList = msgKeys.map((msgKey) => {
                var is_admin = true
                if (allMessages[msgKey].user._id === id) {
                    is_admin = false
                }
                
                return {
                    message: allMessages[msgKey].text,
                    avatar: selectedUser.avatar ? selectedUser.avatar: avatar,
                    username: selectedUser.name,
                    createdAt: this.dateFormatter(allMessages[msgKey].createdAt),
                    is_admin: is_admin
                }
            })
            this.setState({allUserMessages: msgList})
        })
    }

    filterUserById(id) {
        return this.state.allUserDetails.filter(userDetail => {
            return userDetail.id === id
        })
    }

    render() {
        return (
            <Grid container>
                <Grid item xs={3}>
                    <ConversationLists 
                        styles={styles}
                        setActiveId={this.setActiveId}
                        updateProfile={this.updateProfile}
                        pullConversation={this.pullConversation}
                    />
                </Grid>
                <Grid item xs={6}>
                        <Chat 
                            allMessages = {this.state.allUserMessages}
                            sendMessage = {this.sendMessage}
                        />
                </Grid>
                <Grid item xs={3}>
                    <Profile 
                        styles={styles}
                        profile={this.state.userProfile}

                    />
                </Grid>
            </Grid>
        )
    };
}

export default Dashboard;


// WEBPACK FOOTER //
// ./src/Components/Dashboard/Dashboard.js